export default __webpack_public_path__ + "static/media/challenge-bg.745085ce.png";